export default __webpack_public_path__ + "static/media/ExportShipping.9804f6d9.jpg";